import { AseobiOrder } from "src/utils/gql_types";
import AsoebiOrder from "../AsoebiOrder";

interface Props {
  orders: AseobiOrder[];
}

const AsoebiOrders = ({ orders }: Props) => {
  return (
    <div className="md:px-4">
      {orders.map((order) => (
        <AsoebiOrder order={order} key={order.id} />
      ))}
    </div>
  );
};

export default AsoebiOrders;
